<template>
  <div :key="menuItem.name"
       :class="{
         'bx-js-show-dropdown': showDropDownMenu
       }">
    <div :class="{
           'bx-js-has-dropdown': level === 1 && hasChildren
         }"
         @mouseover="handleMouseOver">
      <a :href="menuItem.url"
         :target="menuItem.target"
         :rel="rel">
        {{ menuItem.name }}
        <img v-if="menuItem.icon && menuItem.icon.imageId"
             :src="imageIconUrl"
             :title="menuItem.icon.seoName"
             :alt="menuItem.icon.imageAltText"
             :class="`bx-${menuType}__navi-item-image`">
      </a>
      <button v-if="level === 1 && hasChildren && menuContext !== 'footer'"
              class="bx-header__navi-item-arrow"
              :aria-label="`Unter-Menü '${menuItem.name}' ${showDropDownMenu ? 'schließen' : 'öffnen'}`"
              aria-haspopup="true"
              :aria-expanded="showDropDownMenu"
              :aria-controls="flyoutId"
              @click="handleArrowClick">
        <Icon name="arrow_toggle" />
      </button>
    </div>
    <div v-if="hasChildren"
         :id="flyoutId"
         :class="{
           'bx-js-is-dropdown': true,
           [`bx-${menuType}__navi-list`]: true,
           [`bx-${menuType}__navi-list--level-${level}`]: true
         }"
         @mouseleave="handleMouseLeave">
      <MenuItem v-for="item in menuItem.children"
                :key="item.index"
                :menu-item="item"
                :level="(level + 1)"
                :menu-type="menuType"
                :brand="brand" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'

import { useConfigStore } from '../../stores/config'
import imgSrcSet from '../../mixins/img-src-set'
import Icon from '../shared/Icon.vue'

export default {
  name: 'MenuItem',
  components: { Icon },
  mixins: [imgSrcSet],
  props: {
    menuItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    level: {
      type: Number,
      default: 0
    },
    menuType: {
      type: String,
      default: ''
    },
    menuContext: {
      type: String,
      default: 'footer',
      validator: function (value) {
        return ['burger', 'desktop', 'footer'].includes(value)
      }
    },
    brand: {
      type: String,
      default: null
    },
    openedMenuItem: {
      type: String,
      default: ''
    }
  },
  emits: ['menu-item-hovered'],
  data () {
    return {
      showDropDownMenu: false
    }
  },
  computed: {
    // this store prop is only used by a mixin
    ...mapState(useConfigStore, ['rsConfig']),
    rel () {
      if (this.menuItem.target === '_blank' && this.menuItem.url && !this.menuItem.url.startsWith('/')) {
        // external links with target blank should have rel="noopener" for security and lighthouse score
        return 'noopener'
      } else {
        return ''
      }
    },
    hasChildren () {
      return !!(this.menuItem.children &&
          this.menuItem.children.length > 0)
    },
    imageIconUrl () {
      const ratio = this.getCroppedImgSize(this.menuItem.icon).width / this.getCroppedImgSize(this.menuItem.icon).height
      return this.createImgSrc({
        image: this.menuItem.icon,
        brand: this.brand,
        width: Math.ceil(ratio * 20)
      })
    },
    flyoutId () {
      return `flyout-${this.menuContext}-${this.menuItem.name.replace(/\s+/g, '-').toLowerCase()}`
    }
  },
  watch: {
    openedMenuItem (newVal) {
      if (this.menuItem.name !== newVal) {
        this.showDropDownMenu = false
      }
    }
  },
  methods: {
    handleMouseOver (event) {
      if (this.menuContext !== 'desktop' ||
        !this.isElementReallyVisible(event.target)
      ) return

      this.showDropDownMenu = true
      this.$emit('menu-item-hovered', this.menuItem.name)
    },
    handleMouseLeave () {
      if (this.menuContext !== 'desktop') return

      this.showDropDownMenu = false
      this.$emit('menu-item-hovered', '')
    },
    handleArrowClick () {
      this.showDropDownMenu = !this.showDropDownMenu
      this.$emit('menu-item-hovered', this.showDropDownMenu ? this.menuItem.name : '')
    },
    isElementReallyVisible (el) {
      const rect = el.getBoundingClientRect()
      const centerX = rect.left + rect.width / 2
      const centerY = rect.top + rect.height / 2
      const topElement = document.elementFromPoint(centerX, centerY)
      return el === topElement || el.contains(topElement)
    }
  }
}
</script>
